import { useState } from "react";
import { useTranslation } from "react-i18next";
import { api, fehlertext } from "./api";
import { Fehler, Karte, Knopf, Seitenkopf, Textfeld } from "./ui";

/**
 * Hinweise an den Chef.
 *
 * Ein Feld, ein Knopf. Was hier steht, geht als Mail an die
 * Geschaeftsleitung und wird nirgends gespeichert: kein Postfach in der
 * Anwendung, keine Zuordnung zu einem Objekt, keine Akte. Deshalb steht der
 * Satz dazu auch auf der Seite und nicht nur in der Dokumentation. Wer weiss,
 * dass die Notiz nicht in einer Akte landet, schreibt eher, was er wirklich
 * denkt.
 *
 * **Diktieren** braucht keinen eigenen Knopf. Jede Handytastatur hat eine
 * Mikrofontaste, die in dieses Feld schreibt, und sie ist besser als alles,
 * was wir in ein paar Tagen bauen koennten: sie kennt die Sprache des
 * Mitarbeiters und laeuft auf dem Geraet. Eine eigene Aufnahme mit
 * Uebertragung an einen Spracherkennungsdienst waere dagegen eine Tonaufnahme
 * vom Arbeitsplatz, also ein Datenschutzvorgang mit Einwilligung,
 * Auftragsverarbeiter und Loeschfrist. Fuer eine Notiz an den Chef steht das
 * in keinem Verhaeltnis.
 *
 * Nach dem Senden bleibt der Text nicht stehen. Ein abgeschickter Hinweis im
 * Feld verleitet zum zweiten Klick, und dann kommt dieselbe Nachricht zweimal.
 */

const MINDESTLAENGE = 5;
const HOECHSTLAENGE = 4000;

export function HinweisSeite() {
  const { t } = useTranslation();
  const [text, setText] = useState("");
  const [laeuft, setLaeuft] = useState(false);
  const [gesendet, setGesendet] = useState(false);
  const [fehler, setFehler] = useState<string | null>(null);

  async function senden() {
    setFehler(null);
    setLaeuft(true);
    try {
      await api.post("/hinweis", { text: text.trim() });
      setText("");
      setGesendet(true);
    } catch (e) {
      setFehler(fehlertext(e));
    } finally {
      setLaeuft(false);
    }
  }

  if (gesendet) {
    return (
      <>
        <Seitenkopf titel={t("nav.hinweis")} />
        <Karte>
          <p className="text-tinte">{t("hinweis.gesendet")}</p>
          <div className="mt-4">
            <Knopf art="neben" onClick={() => setGesendet(false)}>{t("hinweis.nochEiner")}</Knopf>
          </div>
        </Karte>
      </>
    );
  }

  return (
    <>
      <Seitenkopf titel={t("nav.hinweis")} hinweis={t("hinweis.hinweis")} />
      <Fehler text={fehler} />
      <Karte>
        <Textfeld
          rows={8}
          value={text}
          maxLength={HOECHSTLAENGE}
          placeholder={t("hinweis.platzhalter")}
          onChange={(e) => setText(e.target.value)}
        />
        <p className="mt-2 text-sm text-leise">{t("hinweis.diktieren")}</p>
        <div className="mt-4">
          <Knopf
            disabled={laeuft || text.trim().length < MINDESTLAENGE}
            onClick={() => void senden()}
          >
            {t("hinweis.senden")}
          </Knopf>
        </div>
      </Karte>
    </>
  );
}
